// `chrome-extension.notifications` — the shell's SECOND iframe (plan §1.3, §7 phase 3 slice 1).
//
// ⚠️ RENDERING NOTHING IS THE CORRECT RESTING STATE, not an unfinished port. The whole of
// `extension-user-notifications.tpl.html` sits behind `ng-if="ctrl.isNotificationOpen"`, so
// production paints an empty frame until a notification arrives — which is why the baseline
// records this route as `renders-nothing` with `textLength: 0` both signed out AND signed in,
// and why that is filed as a known gap rather than a failure.
//
// It is worth a route of its own precisely because of that. The shell loads this URL with
// `?frameRole=notifications` into a frame the user never focuses; without a route it falls to
// the catch-all, which paints a "Not ported yet" page — visible text in a frame that is
// supposed to be invisible, floating over whatever ATS page the user is on. An empty div is
// both more correct and less work.
//
// What is NOT here: the notification bodies (`notification/new-candidate`, `new-job`, `nudge`,
// `update-candidate`, `zero-alerts`) and the handler that decides which to show. They are
// driven by Pusher and by `ExtensionStorageServiceLoaded`, neither of which exists before the
// shell's messaging layer — so the slide-in container is deliberately absent rather than
// stubbed: an empty animated wrapper that can never fill is worse than no wrapper.
import type { ReactElement } from 'react'
import { useRouteChrome } from './useRouteChrome.ts'

export function NotificationsFrame(): ReactElement {
  // `data.bodyClass: 'no-min-width'` — the same 1200px cancellation every extension surface
  // needs, and this frame is narrower than any of them.
  useRouteChrome()
  return <></>
}
